import { Delimiter } from 'src/shared/design-system/Utilities/TextReplace';

export const PHOTO_SIZE = 100;
export const PHOTO_VIDEO_SIZE = 240;

export const DEFAULT_ACCEPT = 'image/jpeg, image/png, video/mp4, video/x-m4v, video/*';
export const PHOTO_ACCEPT = 'image/jpeg, image/png';

export const DROP_ZONE_TEXT = {
  DROP_ZONE: `Drag photo or video here ${Delimiter} ${Delimiter} from your device`,
  DROP_ZONE_NO_VIDEO: `Drag photo here ${Delimiter} ${Delimiter} from your device`,
  REPLACE_1: `or`,
  REPLACE_2: `Select`,
};
